import LOCATIONOFFERED from 'data/mantechcar24/location-offered.json';
import { useI18n } from 'hooks/useI18n';
import {
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const LocationOffered: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={400} width="99%" minWidth={500}>
          <LineChart
            width={500}
            height={300}
            data={LOCATIONOFFERED}
            margin={{
              top: 35,
              right: 30,
              left: 20,
              bottom: 0
            }}
          >
            <XAxis
              dataKey="year"
              type="category"
              tickLine={false}
              tickMargin={10}
            />
            <YAxis
              domain={[0, 100]}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
              tickLine={false}
              tickMargin={5}
            />
            <Tooltip
              labelStyle={{
                borderBottom: '1px solid #4d485c',
                marginBottom: '6px',
                fontWeight: 900
              }}
              formatter={(value: number) => value.toFixed(1) + '%'}
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ top: 0 }}
            />
            <Line
              type="linear"
              dataKey="onsite"
              stroke="#1B9D76"
              name={t('mantechcar24.companies.locations-offered.onsite')}
            />
            <Line
              type="linear"
              dataKey="remote"
              stroke="#D95F02"
              name={t('mantechcar24.companies.locations-offered.remote')}
            />
            <Line
              type="linear"
              dataKey="hybrid"
              stroke="#746FB3"
              name={t('mantechcar24.companies.locations-offered.hybrid')}
            />
          </LineChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default LocationOffered;
